enum AlignmentOption {
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom',
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

enum DistributeOption {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

type Boundary = {
  top: number;
  left: number;
  bottom: number;
  right: number;
};

export { AlignmentOption, DistributeOption };

export type { Boundary };
